import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const defaultSnackBarConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: "center",
    verticalPosition: "bottom",
    panelClass: ['snack-bar-general']
}